import type * as React from "react";
import type { DomainStatus, ProvisioningStatus } from "@/types/api";
import { Badge, type BadgeProps } from "@/components/ui/badge";

type Variant = NonNullable<BadgeProps["variant"]>;

const DOMAIN_VARIANT: Record<DomainStatus, Variant> = {
    PURCHASING: "warning",
    NS_DELEGATED: "warning",
    ZONE_ACTIVE: "warning",
    WORKER_ATTACHED: "warning",
    AVAILABLE: "success",
    ASSIGNED: "default",
    RETIRED: "muted",
    FAILED: "destructive",
};

const DOMAIN_LABEL: Record<DomainStatus, string> = {
    PURCHASING: "Purchasing",
    NS_DELEGATED: "NS delegated",
    ZONE_ACTIVE: "Zone active",
    WORKER_ATTACHED: "Worker attached",
    AVAILABLE: "Available",
    ASSIGNED: "Assigned",
    RETIRED: "Retired",
    FAILED: "Failed",
};

export function DomainStatusPill({ status }: { status: DomainStatus }): React.ReactNode {
    return <Badge variant={DOMAIN_VARIANT[status]}>{DOMAIN_LABEL[status]}</Badge>;
}

const JOB_VARIANT: Record<ProvisioningStatus, Variant> = {
    PENDING: "muted",
    RUNNING: "warning",
    SUCCEEDED: "success",
    FAILED: "destructive",
    DEAD_LETTER: "destructive",
};

const JOB_LABEL: Record<ProvisioningStatus, string> = {
    PENDING: "Pending",
    RUNNING: "Running",
    SUCCEEDED: "Succeeded",
    FAILED: "Failed",
    DEAD_LETTER: "Dead letter",
};

export function ProvisioningStatusPill({ status }: { status: ProvisioningStatus }): React.ReactNode {
    return <Badge variant={JOB_VARIANT[status]}>{JOB_LABEL[status]}</Badge>;
}
